module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"shared":{"users":{"edit":{"privacy_hint_html":"Diese Sektion wird nur öffentlich auf Ihrem Profil angezeigt, wenn sie in den <a href=\\"%{link}\\" nofollow target=\\"_blank\\">Privatsphäre Einstellungen</a> für <strong>alle</strong> zugänglich gemacht wird."}}}}}}')
  delete Component.options._Ctor
}
